"use strict";exports.__esModule = true;exports.callChildRef = void 0;



var callChildRef = exports.callChildRef = function callChildRef(
componentRef,
instance)
{
  if (!componentRef) {
    return;
  }
  if (typeof componentRef === 'function') {
    componentRef(instance);
  }
  if (Object.prototype.hasOwnProperty.call(componentRef, 'current')) {
    // @ts-expect-error: will be fixed in #2807
    componentRef.current = instance;
  }
};